import type { RestaurantType } from 'types/restaurant';
import type { NavItemType } from 'types/menu';

type RestaurantPolicy = Pick<RestaurantType, 'mode' | 'maintains_shifts'>;

export interface RestaurantPolicyDestinations {
  showApiReservations: boolean;
  showCustomerRequests: boolean;
  usesApiAssignments: boolean;
}

export function getRestaurantPolicyDestinations(restaurant?: RestaurantPolicy | null): RestaurantPolicyDestinations {
  const isApiMode = restaurant?.mode === 'api';
  const usesApiAssignments = isApiMode && restaurant?.maintains_shifts === true;

  return {
    showApiReservations: isApiMode,
    showCustomerRequests: restaurant?.mode === 'non_api' || (isApiMode && restaurant.maintains_shifts === false),
    usesApiAssignments
  };
}

export function getReservationNavigationItems(item: NavItemType, restaurant?: RestaurantPolicy | null): NavItemType[] {
  if (item.id !== 'reservations' || !restaurant) {
    return [item];
  }

  const { showApiReservations, showCustomerRequests } = getRestaurantPolicyDestinations(restaurant);
  const customerRequestsItem: NavItemType = {
    ...item,
    id: 'customer-requests',
    title: 'Customer Requests',
    url: item.nonApiUrl || '/restaurant/customer-requests'
  };

  if (showApiReservations && showCustomerRequests) {
    return [item, customerRequestsItem];
  }

  return showCustomerRequests ? [customerRequestsItem] : [item];
}
